/**
 * Tawk.to Chat Integration
 * 
 * This module handles the initialization of the Tawk.to live chat widget
 * across the entire application.
 */

/**
 * Initialize the Tawk.to chat widget
 */
export const initializeTawkTo = () => {
    // Check if already initialized
    if (window.Tawk_API) {
        return;
    }
    
    // Load config to get Tawk.to widget ID
    fetch('/json/config.json')
        .then(response => response.json())
        .then(config => {
            // Get widget ID from config
            const widgetId = config.tawkto?.widgetId;
            
            // If widget ID is not available in config, log error and return
            if (!widgetId) {
                console.error('Tawk.to widget ID not found in config');
                return;
            }
            
            // Using the official Tawk.to script snippet
            var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
            
            try {
                // Store Tawk_API reference in window object
                window.Tawk_API = Tawk_API;
                window.Tawk_LoadStart = Tawk_LoadStart;
                
                // Create and insert the script as per official snippet
                const s1 = document.createElement("script");
                const s0 = document.getElementsByTagName("script")[0];
                
                s1.async = true;
                s1.src = 'https://embed.tawk.to/' + widgetId;
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                
                // Insert the script into the DOM
                s0.parentNode.insertBefore(s1, s0);
                
                console.log('Tawk.to chat widget initialized with ID:', widgetId);
            } catch (error) {
                console.error('Error initializing Tawk.to chat widget:', error);
            }
        })
        .catch(error => {
            console.error('Error loading config for Tawk.to initialization:', error);
        });
};

/**
 * Open the Tawk.to chat widget
 */
export const openTawkToChat = () => {
    try {
        if (!window.Tawk_API) {
            console.warn('Tawk.to not initialized yet');
            return;
        }
        
        // First check if we can directly use maximize
        if (typeof window.Tawk_API.maximize === 'function') {
            window.Tawk_API.maximize();
            console.log('Tawk.to chat maximized');
        } 
        // Otherwise try toggle
        else if (typeof window.Tawk_API.toggle === 'function') {
            window.Tawk_API.toggle();
            console.log('Tawk.to chat toggled');
        }
        // Last resort, try popup
        else if (typeof window.Tawk_API.popup === 'function') {
            window.Tawk_API.popup();
            console.log('Tawk.to chat opened in popup');
        } 
        // If none of these work, provide a fallback
        else {
            console.warn('Could not find method to open Tawk.to chat');
            // Try to get the widget ID from config
            fetch('/json/config.json')
                .then(response => response.json())
                .then(config => {
                    const widgetId = config.tawkto?.widgetId;
                    if (widgetId) {
                        window.open('https://tawk.to/chat/' + widgetId, '_blank');
                    } else {
                        console.error('Tawk.to widget ID not found in config');
                    }
                })
                .catch(error => {
                    console.error('Error loading config for Tawk.to chat:', error);
                });
        }
    } catch (error) {
        console.error('Error opening Tawk.to chat:', error);
    }
};

export default {
    initializeTawkTo,
    openTawkToChat
};
